import { Component, OnInit, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { BUSNThirdPartyService } from '@takectrl-multiapp/svcs-core-business';
import { SharedConfig } from '@takectrl-multiapp/svcs-share-config';
declare const dataLayer: any[];

@Component({
  selector: 'quote-info',
  standalone: false,
  templateUrl: './quote-info.component.html',
  styleUrls: ['./quote-info.component.scss'],
})
export class QuoteInfoComponent implements OnInit {
  @ViewChild('slides') swiperSlide: ElementRef | undefined;
  @Output() navigateHomeQuote: EventEmitter<unknown> = new EventEmitter();
  disableLeft = true;
  disableRight: boolean;
  constructor(public thirdpartyService: BUSNThirdPartyService, public sharedConfig: SharedConfig) {}

  ngOnInit(): void {
    dataLayer.push({
      event: 'page_show',
      screenPath: 'quote-info',
      screenName: 'quote-info',
      userUid: SharedConfig.firebaseUserKey ? SharedConfig.firebaseUserKey : 'NaN',
    });
  }

  navHomeQuote() {
    this.navigateHomeQuote.emit();
  }

  sliderAtEnd() {
    this.swiperSlide.nativeElement.swiper.autoplay.stop();
  }

  slideDidChange() {
    const promiseBeginning = this.swiperSlide.nativeElement.swiper.isBeginning();
    const promiseEnd = this.swiperSlide.nativeElement.swiper.isEnd();
    Promise.all([promiseBeginning, promiseEnd]).then((data) => {
      data[0] ? (this.disableLeft = true) : (this.disableLeft = false);
      data[1] ? (this.disableRight = true) : (this.disableRight = false);
    });
  }

  slidePrevious() {
    this.swiperSlide.nativeElement.swiper.slidePrev(100, false);
    const promiseBeginning = this.swiperSlide.nativeElement.swiper.isBeginning();
    Promise.all([promiseBeginning]).then((data) => {
      data[0] ? (this.disableRight = true) : (this.disableRight = false);
      if (data[0]) {
        this.disableLeft = true;
        this.disableRight = false;
      }
    });
  }

  slideNext() {
    this.disableLeft = false;
    this.swiperSlide.nativeElement.swiper.slideNext(100, false);
    const promiseEnd = this.swiperSlide.nativeElement.swiper.isEnd();
    Promise.all([promiseEnd]).then((data) => {
      data[0] ? (this.disableRight = true) : (this.disableRight = false);
      if (data[0]) {
        this.disableRight = true;
        this.disableLeft = false;
      }
    });
  }
}
